module.exports = __webpack_public_path__ + "static/img/img3.2419b535.jpg";